import { theme } from 'antd'

export const darkTheme = {
  algorithm: theme.darkAlgorithm,
  cssVar: true,
  token: {
    colorBgLayout: '#000000'
  }
}

export const lightTheme = {
  algorithm: theme.defaultAlgorithm,
  cssVar: true,
  token: {
    colorBgLayout: '#FFFFFF'
  }
}
